import React from "react";
import {
  Form,
  Row,
  Col, Input, Button,Select,Icon
} from "antd";
import img from './../../assets/img/freepik  Plant  inject 2.png';
import InputMask from "react-input-mask";
import MiCompAPI from "../../util/api";
const { Option } = Select;
class ID extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      isValuenameExists: false,
      isValueEmailExists:false,
    };
    this.api = new MiCompAPI(this.props.userPermandMasters);
  }
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err && !this.state.isValuenameExists&&!this.state.isValueEmailExists) {
        this.props.submitHandler({...values,phoneNo:values.phoneNo.replace(/[^0-9]/g, "").substring(1)},(val)=>{
          if(!val){
          }
        });
      }
    });
  };
  handleChangeUser = (e) => {
    if (e.target.value && e.target.value.length > 4) {
      this.api.invoke("IsValueExists/USERS/" + e.target.value + "/USERNAME", "get", (data, success) => {
        if (success) {
          this.setState({ isValuenameExists: data.data });
        }
      });
    }
  }
  handleChangeEmailUser = (e) => {
    if (e.target.value && e.target.value.length > 4) {
      this.api.invoke("IsValueExists/USERS/" + e.target.value + "/EMAIL", "get", (data, success) => {
        if (success) {
          this.setState({ isValueEmailExists: data.data });
        }
      });
    }
  }
  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div className="mi_model_popup">
        <Row span={24}>
          <Col span={18}>
            <p className='mi_title' style={{ marginLeft: '8px' }}>Invite User
              <br></br>
              <span className='mi_title2'>Fill up the following form in order to invite a User</span>
            </p>
          </Col>
          <Col span={6}>
            <i className="fa fa-times mi_icon mi_icon_red mi_button_close" onClick={() => this.props.closeDrawerHandler("close", null)} ></i>
          </Col>
        </Row>
        <Form onSubmit={this.handleSubmit} layout="vertical" hideRequiredMark>
          <Row span={24}>
            <Col md={12} sm={24}>
              <Form.Item>
                <fieldset className="mi_input_pop">
                  <legend className="legend-font">First Name</legend>
                  {getFieldDecorator('first_Name', {
                    rules: [{ required: true, message: 'Please enter First Name' },
                    {
                      pattern: /^(?!\s)(?![\s\S]*\s$)[A-Za-z\s]+$/,
                      message: "It allows only Alphabets,No whitespace at the beginning and end"
                    }],
                  })(<Input className="mi_input" maxLength={40} type="text" placeholder="Enter First Name *" />)}
                </fieldset>
              </Form.Item>
            </Col>
            <Col md={12} sm={24}>
              <Form.Item>
                <fieldset className="mi_input_pop">
                  <legend className="legend-font">Middle Name</legend>
                  {getFieldDecorator('middle_Name', {
                    rules: [{ required: false, message: 'Please enter Middle Name' }, {
                      pattern: /^(?!\s)(?![\s\S]*\s$)[A-Za-z\s]+$/,
                      message: "It allows only Alphabets,No whitespace at the beginning and end"
                    }],
                  })(<Input className="mi_input" maxLength={40} type="text" placeholder="Enter Middle Name " />)}
                </fieldset>
              </Form.Item>
            </Col>
          </Row>
          <Row span={24}>
            <Col md={12} sm={24}>
              <Form.Item>
                <fieldset className="mi_input_pop">
                  <legend className="legend-font">Last Name</legend>
                  {getFieldDecorator('last_Name', {
                    rules: [{ required: true, message: 'Please enter Last Name' }, {
                      pattern: /^(?!\s)(?![\s\S]*\s$)[A-Za-z\s]+$/,
                      message: "It allows only Alphabets,No whitespace at the beginning and end"
                    }],
                  })(<Input className="mi_input" maxLength={40} type="text" placeholder="Enter Last Name *" />)}
                </fieldset>
              </Form.Item>
            </Col>
            <Col md={12} sm={24}>
              <Form.Item>
                <fieldset className="mi_input_pop">
                  <legend className="legend-font">Email</legend>
                  {getFieldDecorator('email', {
                    rules: [{ required: true, message: 'Please enter email' }, {
                      type: 'email', message: 'The input is not valid E-mail!.',
                    },{ whitespace: true, message: "Email is invalid." }, {
                      pattern: /^([a-zA-Z0-9\s.]+)@([a-zA-Z0-9]+)\.([a-zA-Z]{2,5})$/,
                      message: 'Email is invalid.'}],
                  })(<Input className="mi_input" onChange={this.handleChangeEmailUser.bind(this)}  maxLength={40} type="text" placeholder="Enter Email *" />)}
                </fieldset>
              </Form.Item>
              {this.state.isValueEmailExists ? <p style={{ color: "red", marginTop: '5px', marginLeft: '12px' }}>Email already exists</p> : ""}
            </Col>
          </Row>
          <Row>
            <Col md={12} sm={24}>
              <Form.Item>
                <fieldset className="mi_input_pop">
                  <legend className="legend-font">Phone Number</legend>
                  {getFieldDecorator('phoneNo', {
                    rules: [{ required: true, message: 'Please enter phone number.' },
                    { pattern: /^((\+0?1\s)?)\(?\d{3}\)?[\s.\s]\d{3}[\s.-]\d{4}$/,
                    message: 'phone number is invalid'}],
                  })(
                    <InputMask mask="+1 (999) 999-9999" autoComplete={"nope"}  type="text" className="ant-input mi_input" placeholder="Enter Phone Number *"/>
                  )
                  }
                </fieldset>
              </Form.Item>
            </Col>
            <Col md={12} sm={24}>
              <Form.Item>
                <fieldset className="mi_input_pop">
                  <legend className="legend-font">Role</legend>
                  {getFieldDecorator('role_Id', {
                    rules: [{ required: true, message: 'Please select User role.' }],
                  })(<Select suffixIcon={<Icon style={{transform:'rotate(90deg)'}} type="double-right" />} className="mi_input"
                    optionFilterProp="children"
                    showSearch={true}
                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    onChange={this.onChange}
                    placeholder="Please Select User Role *">
                    {this.props.roles?this.props.roles.map(tag => <Option value={tag.id} key={tag.id}>{tag.name}</Option>):""}
                  </Select>)}
                </fieldset>
              </Form.Item>
            </Col>
          </Row>
          <Row span={24} style={{ marginTop: '20px' }}>
            <Col span={7}>
              <img alt="example" style={{ height: '60px', marginBottom: '-26px', float: 'left' }} src={img} />
            </Col>
            <Col span={5}>
              <Button className="mi_button_right submit-button" onClick={() => this.props.closeDrawerHandler("close", null)} style={{ marginRight: 8 }}>
                Cancel
                    </Button>
            </Col>
            <Col span={5}>
              <Button htmlType="submit"  className="submit-button" type="primary" >
                Submit
                </Button>
            </Col>
            <Col span={7}>
            </Col>
          </Row>
        </Form>
      </div>
    );
  }
}
const InviteUserDrawer = Form.create()(ID);
export default InviteUserDrawer;
